<template>
  <div style="background-color: #2d3237; margin-top: 1rem;">
    <div class="footer_item contact_box">
      <h2>联系方式</h2>
      <ul>
        <li>
          座机：0579-85553367
        </li>
        <li>
          QQ：1158292145
        </li>
      </ul>
    </div>
    <van-cell :border="false">
      <div class="copyright">
        Copyright © 2022 义乌市伊拉文进出口有限公司 版权所有
      </div>
    </van-cell>
  </div>
</template>

<script>
  import {Button, Cell, CellGroup, NavBar, Icon, Popup, Divider } from "vant";
  export default {
    name: 'MyHeader',
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Popup.name]: Popup,
      [Divider.name]: Divider,
      [Button.name]: Button
    },
    data () {
      return {
        menuShow: false
      }
    },
    props: {
    },
    watch:{
    },
    methods: {
    }
  }
</script>

<style scoped>
  .van-cell{
    color: #ffffff;
    background-color: transparent;
  }
  .copyright{
    color: #555;
    font-weight: normal;
    margin: 0 auto;
    text-align: center;
    font-size: 0.6rem;
  }
  .footer_item {
    border-bottom: 1px solid #373c41;
    padding: 0 1.5rem;
  }
  .footer_item h2 {
    font-size: 1.4rem;
    color: #aaa;
    padding-top: 1rem;
    margin: 0;
    font-weight: normal;
  }
  .footer_item > ul {
    display: -webkit-flex;
    padding-left: 0;
    margin: 0.75rem 0;
  }
  .contact_box ul li {
    width: 50%;
    margin: 0;
    float: left;
  }
  .footer_item ul li {
    list-style: none;
    font-size: .84rem;
    line-height: .72rem;
    color: #777;
    float: left;
    margin-right: 0.35rem;
  }
</style>
